import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Represents an extra item or enhancement that can be added to ceremony
 */
export interface Enhancement {
	description: string;
	maxStockCount: number;
	name: string;
	price: number;
	image: string;
}

@Component({
	selector: 'app-enhancement-item',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './enhancement-item.component.html',
	styleUrl: './enhancement-item.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnhancementItemComponent {

	/**
	 * The enhancement item to display.
	 */
	@Input({required: true}) enhancement!: Enhancement;
}
